// Environment variables utility
// This helps with type safety and default values

// IMPORTANT: For static exports with token substitution:
// - Build-time: Use #{TOKEN_*}# placeholders that get baked into the bundle
// - Release-time: Replace these tokens with actual values in the release pipeline

// Log environment variables for debugging
if (typeof window !== "undefined") {
  console.log("Client-side environment variables:")
  console.log("NEXT_PUBLIC_API_URL:", process.env.NEXT_PUBLIC_API_URL)
  console.log("NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT:", process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT)
  console.log("NEXT_PUBLIC_COMMISSION_SERVICE_API_URL:", process.env.NEXT_PUBLIC_COMMISSION_SERVICE_API_URL)
  console.log("NEXT_PUBLIC_ENABLE_COMMISSION_CALCULATOR:", process.env.NEXT_PUBLIC_ENABLE_COMMISSION_CALCULATOR)
  console.log("NEXT_PUBLIC_ENABLE_WO_HOURLY_TIER_BASIS:", process.env.NEXT_PUBLIC_ENABLE_WO_HOURLY_TIER_BASIS)
  console.log("NEXT_PUBLIC_USE_MOCK_DATA:", process.env.NEXT_PUBLIC_USE_MOCK_DATA)
  console.log("NEXT_PUBLIC_BASE_PATH:", process.env.NEXT_PUBLIC_BASE_PATH)
  console.log("NEXT_PUBLIC_BUILD_ENV:", process.env.NEXT_PUBLIC_BUILD_ENV)
  console.log("NEXT_PUBLIC_ALLOWED_TOKEN_ORIGINS:", process.env.NEXT_PUBLIC_ALLOWED_TOKEN_ORIGINS)
}

// Application environment variables
// These will be token placeholders at build time, replaced in release pipeline
export const env = {
  // API URL for backend services
  apiUrl: process.env.NEXT_PUBLIC_API_URL || "#{API_URL}#",

  // Admin Service API Endpoint
  adminServiceApiEndpoint: process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT || "#{ADMIN_SERVICE_API_ENDPOINT}#",

  // Commission Plan Service API Endpoint
  commissionServiceEndpoint: process.env.NEXT_PUBLIC_COMMISSION_SERVICE_API_URL || "#{COMMISSION_SERVICE_API_URL}#",

  // Whether to enable the commission calculation simulator feature
  enableCommissionCalculator: process.env.NEXT_PUBLIC_ENABLE_COMMISSION_CALCULATOR || "#{ENABLE_COMMISSION_CALCULATOR}#",

  // Whether to enable WO Hourly tier basis options in the dropdown
  enableWoHourlyTierBasis: process.env.NEXT_PUBLIC_ENABLE_WO_HOURLY_TIER_BASIS || "#{ENABLE_WO_HOURLY_TIER_BASIS}#",

  // Whether to use mock data instead of real API calls
  useMockData: process.env.NEXT_PUBLIC_USE_MOCK_DATA || "#{USE_MOCK_DATA}#",

  // Build environment
  buildEnv: process.env.NEXT_PUBLIC_BUILD_ENV || "#{BUILD_ENV}#",

  // Base path
  basePath: process.env.NEXT_PUBLIC_BASE_PATH || "#{BASE_PATH}#",

  // Security: Allowed origins for postMessage token exchange (comma-separated)
  allowedTokenOrigins: process.env.NEXT_PUBLIC_ALLOWED_TOKEN_ORIGINS || "#{ALLOWED_TOKEN_ORIGINS}#",
}

// Log the final env object for debugging
if (typeof window !== "undefined") {
  console.log("Final env object:", env)
}

